module.exports = __webpack_public_path__ + "img/phone1.42df2919.png";